var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8317281,0.350430246 C15.6383291,0.156892965 15.315947,0.162476575 15.119182,0.355529098 L6.30296026,9.005407 C6.10283093,9.20176029 5.77562385,9.19596589 5.58743998,9.00778202 L2.8734061,6.29374814 C2.67836449,6.09870652 2.35489125,6.10595483 2.16982178,6.29102431 L0.350430246,8.11041584 C0.156892965,8.30395312 0.158896541,8.62455767 0.353820725,8.82538865 L5.58677333,14.2169156 C5.78218312,14.4182469 6.09306951,14.4289599 6.28850312,14.2334972 L17.6520909,2.86821302 C17.8442358,2.67603947 17.8347573,2.35489125 17.6498201,2.16982178 L15.8317281,0.350430246 Z",
    id: "Page-1",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWhite);
export default __webpack_public_path__ + "static/media/tick_white.3974a54fade33339a4e0a9708fd5538a.svg";
export { ForwardRef as ReactComponent };